'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerDetail = require('./remote/sellerDetail');

var SellerDetail = {
    fetchSellerDetailsByIds: function fetchSellerDetailsByIds(params) {
        return _sellerDetail.SellerDetailRemote.fetchSellerDetailsByIds(params);
    }
};

exports.default = SellerDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/sellerDetail.js
// module id = HW2X
// module chunks = 46